<div class="user-detail">
  <div class="header mt-3">
    <div class="d-flex justify-content-between">
      <img
        src="/assets/svg/ico-chevron-back-outline.svg"
        alt="back button"
        class="pointer-cursor"
        *ngIf="stepper > 0"
        (click)="navigateBack()"
      />

      <h1 class="modal-title m-auto">{{ "USER_ADD_USER" | translate }}</h1>

      <!-- dynamic back button render -->
      <ng-content select="[backButton]"></ng-content>
    </div>

    <div class="row my-2 mx-2 pt-4">
      <form
        class="form-inline md-form form-sm form-control form-control-sm px-2 py-2 search-field"
      >
        <img class="d-inline" src="assets/svg/ico-search.svg" />
        <input
          class="field ml-2 w-75"
          type="text"
          [placeholder]="'SEARCH_FOR_EXISTING_USER' | translate"
          aria-label="Search"
          (input)="searchUser()"
          mdbInput
          [(ngModel)]="userSearch"
        />
        <img
          *ngIf="userSearch.length > 0"
          class="d-inline pointer-cursor search-cross"
          src="assets/svg/ico-hamburger-close.svg"
          (click)="removeUser()"
        />
      </form>
      <!-- <app-search-field class="col-12" (click)="navigateToSearch()"></app-search-field> -->
    </div>

    <div class="d-flex d-flex mt-4 pt-2 pb-3" *ngIf="!searchKeyPress">
      <h2 class="heading1 m-auto">{{ "USER_NEW_USER" | translate }}</h2>
    </div>
  </div>
  <form
    [formGroup]="formGroup"
    tabindex="0"
    (keyup.enter)="submit()"
    novalidate
    id="verifyEmail"
  >
    <ng-container *ngIf="searchKeyPress && !selectedUserPanel">
      <div class="mt-4 user-list">
        <ng-container *ngIf="userList$ | async as userList; else loading">
          <div *ngIf="userList.length > 0">
            <div class="scroll-y-users">
              <ng-container *ngFor="let user of userList; let i = index">
                <ng-container *ngIf="!user?.isDeactivated">
                  <div class="col-11 pl-2" *ngIf="checkIfNew(user?.name, i)">
                    <div class="heading mb-1 mt-2">
                      {{ user?.name.charAt(0).toUpperCase() }}
                    </div>
                  </div>
                  <div
                    class="row py-3 mx-2 my-3 item pointer-cursor"
                    (click)="selectUser(user); selectedUser = true"
                  >
                    <div class="col-1 m-auto align-self-center offset-1">
                      <app-profile-picture
                        [name]="user?.name"
                        [userData]="user"
                      >
                      </app-profile-picture>
                    </div>
                    <div class="col-10 pl-4">
                      <div class="col-12 heading3">
                        <app-with-tooltip>
                          {{ user?.name }}
                        </app-with-tooltip>
                      </div>
                      <div class="col-12 usertype">{{ user?.userType }}</div>
                    </div>
                  </div>
                </ng-container>
              </ng-container>
            </div>
          </div>

          <ng-container *ngIf="userList.length < 1">
            <!-- Error messages -->
            <div
              class="mb-2 mx-2 alert alert-danger alert-dismissible fade show notification-alert"
              role="alert"
            >
              {{ "RECORD_NOT_FOUND" | translate }}
            </div>
          </ng-container>
        </ng-container>
        <ng-template #loading>
          <ng-container *ngIf="searchKeyPress">
            <app-nested-loader></app-nested-loader>
          </ng-container>
        </ng-template>
      </div>
    </ng-container>

    <ng-container *ngIf="selectedUserPanel">
      <div class="mt-4 user-list">
        <div class="row py-3 mx-2 item">
          <div class="col-1 m-auto align-self-center offset-1">
            <app-profile-picture
              [name]="currentUser?.name"
              [userData]="currentUser"
            >
            </app-profile-picture>
          </div>
          <div class="col-7 pl-4">
            <div class="col-12 heading3">
              <app-with-tooltip>{{ currentUser?.name }}</app-with-tooltip>
            </div>
            <div class="col-12 usertype">{{ currentUser?.userType }}</div>
          </div>
          <div
            (click)="removeUser()"
            class="pointer-cursor col-2 offset-1 m-auto px-1 text-right align-self-center"
          >
            <img src="assets/svg/ico-circle-cross-black.svg" />
          </div>
        </div>
      </div>
    </ng-container>

    <!-- form start -->

    <ng-container *ngIf="!searchKeyPress">
      <div class="form-group rounded-top form-container mt-4">
        <mat-form-field
          appearance="fill"
          class="w-100 bottom-error-display mb-2 primary-input text-height"
        >
          <mat-label>{{
            "ACCESS_DETAIL_EMAIL_ASTERISK" | translate
          }}</mat-label>
          <textarea
            matInput
            cdkTextareaAutosize
            cdkAutosizeMinRows="1"
            cdkAutosizeMaxRows="2"
            [rows]="isFrench() && !formGroup.controls.email.value ? 2 : 1"
            [placeholder]="'EMAIL_OF_NEW_OR_EXISTING_USER' | translate"
            formControlName="email"
            (keyup)="flagReset()"
          ></textarea>
          <mat-error *ngIf="formGroup?.controls?.email?.errors?.required">
            {{ "ACCESS_DETAIL_EMAIL_IS_REQURED" | translate }}
          </mat-error>
          <mat-error
            *ngIf="
              formGroup?.controls?.email?.errors?.email &&
              !formGroup?.controls?.email?.errors?.required
            "
          >
            {{ "PLEASE_ENTER_A_VALID_EMAIL" | translate }}
          </mat-error>
        </mat-form-field>
      </div>
    </ng-container>

    <!-- Shows error if their inviteSent is over the 250 -->
    <ng-container *ngIf="dashboardList">
      <app-remaining-invite-dialog
        [recurrentRevenue]="dashboardList.recurrentRevenue"
      ></app-remaining-invite-dialog>
    </ng-container>

    <!-- form end -->
  </form>

  <div class="row mt-auto">
    <div class="col-12">
      <button
        class="btn px-3 w-100 btn-submit"
        [disabled]="formGroup.invalid"
        type="submit"
        (click)="submit()"
      >
        {{ "CONTINUE" | translate }}
      </button>
    </div>
  </div>
</div>
